import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { NameMap, Template } from './templates-state/templates.model';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {
  private _apiUrl = environment.apiUrl;
  private _httpClient = inject(HttpClient);

  constructor() {

  }

  getTemplates(): Observable<Template[]> {
    return this._httpClient.get<Template[]>(`${this._apiUrl}/v1/templates/get-all-templates`);
  }

  getFilteredTemplates(payload: { type: string, key: string, stakeholders: string[] }): Observable<Template[]> {
    return this._httpClient.post<Template[]>(`${this._apiUrl}/v1/templates/get-filtered-values`, payload);
  }

  getDistinctDocuments(): Observable<Template[]> {
    return this._httpClient.get<Template[]>(`${this._apiUrl}/v1/templates/get-distinct-documents`);
  }

  createTemplateForm(template: any): Observable<any[]> {
    return this._httpClient.post<any[]>(`${this._apiUrl}/v1/templates/create-template-form`, template);
  }
  updateTemplateForm(template: any): Observable<any[]> {
    return this._httpClient.post<any[]>(`${this._apiUrl}/v1/templates/update-template-form`, template)
  }

  deleteValueEntry(_id: string): Observable<Template> {
    return this._httpClient.delete<Template>(`${this._apiUrl}/v1/templates/delete-value-entry/${_id}`);
  }

  deleteFooterEntry(_id: string): Observable<Template> {
    return this._httpClient.delete<Template>(`${this._apiUrl}/v1/templates/delete-footer-entry/${_id}`);
  }

  createOrUpdateTemplate(payload) {
    return this._httpClient.post(`${this._apiUrl}/v1/templates/create-update-template`, payload);
  }

  deleteTemplate(payload: { type: string, key: string, stakeholders: string[] }) {
    return this._httpClient.delete(`${this._apiUrl}/v1/templates/delete-template`, { body: payload });
  }

  getStakeholdersMap(): Observable<NameMap[]> {
    return this._httpClient.get<NameMap[]>(`${this._apiUrl}/v1/templates/get-stakeholders-map`);
  }

  getAvailableStakeholders(key: string): Observable<any> {
    return this._httpClient.get<any>(`${this._apiUrl}/v1/templates/get-available-stakeholders/${key}`);
  }

  getFormValues(payload: { type: string, stakeholders: string[] }): Observable<Template[]> {
    return this._httpClient.post<Template[]>(`${this._apiUrl}/v1/templates/get-template-form-values`, payload);
  }

}
